import React, { useState } from 'react';
import KernelCapsLockWarning from '../../components/KernelCapsLockWarning';
import { useParams, useNavigate, Link } from 'react-router-dom';
import PortalLayout from '../../components/PortalLayout';
import { loginCustomer, errorMessage } from '../../services/customerApi';
import { useLanguage } from '../../i18n/LanguageContext';

function PortalLogin({ onLogin }) {
  const { t } = useLanguage();
  const { projectSlug } = useParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await loginCustomer(projectSlug, email, password);
      onLogin(res.token, res.customer);
      navigate('/portal/dashboard');
    } catch (err) {
      setError(errorMessage(err, t('portal.loginError')));
    } finally {
      setLoading(false);
    }
  };

  return (
    <PortalLayout title={t('portal.loginTitle')} subtitle={t('portal.loginSubtitle')}>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit} className="card">
        <div className="card-body">
          <div className="form-group">
            <label>{t('portal.email')}</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>{t('portal.password')}</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <KernelCapsLockWarning />
          </div>
          <button type="submit" className="btn" disabled={loading}>
            {loading ? t('portal.loggingIn') : t('portal.loginSubmit')}
          </button>
        </div>
      </form>
      <p className="portal-note">
        {t('portal.noAccount')} <Link to={`/portal/${projectSlug}/register`}>{t('portal.registerCta')}</Link>
      </p>
    </PortalLayout>
  );
}

export default PortalLogin;
